import type { FetchModels, ViewsModels } from '../types';

export function processFetchedResult<T extends FetchModels.Response>(
  response: T,
): T extends FetchModels.Response200Ok ? ViewsModels.RelatedService[] : FetchModels.ResponseWithError {
  let result;

  if ('relatedServices' in response) {
    result = response.relatedServices.map((item): ViewsModels.RelatedService => {
      return {
        iconLeftSrc: item.imageUrl,
        title: item.title,
        description: item.message,
        price: {
          value: item.price,
          currencySlug: item.currency,
        },
        serviceKey: item.serviceKey,
        serviceId: item.serviceId,
        categoryId: item.categoryId,
        serviceHref: item.serviceURL,
        sales: item.sales,
        isCompensationEnabled: item?.isCompensationEnabled,
      };
    });
  } else {
    result = response;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return result as any;
}
